import { render, staticRenderFns } from "./MonthsEstablishmentSettings.vue?vue&type=template&id=56755f2d&"
import script from "./MonthsEstablishmentSettings.vue?vue&type=script&lang=js&"
export * from "./MonthsEstablishmentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports